import React from 'react';

import { css } from '@emotion/react';
import { Modal, SemanticColorToken, Type } from '@robinhood/design';
import { ModalWidth } from '@robinhood/design/product/components/Modal';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  title: string;
  description: string;
  visible: boolean;
  onPrimaryButtonClick: () => void;
  onClose?: () => void;
  variant?: ModalWidth;
}

const AlertModal = ({
  title,
  description,
  visible,
  variant = 'standard',
  onPrimaryButtonClick,
  onClose,
}: PropsIface) => {
  if (!visible) return null;
  return (
    <Modal width={variant} overrideModalStyles={root} onClose={onClose}>
      <Type.Display size='S' overrideRootStyles={{ textAlign: 'center' }}>
        {title}
      </Type.Display>
      <Type.Text size='M' overrideRootStyles={{ textAlign: 'center' }}>
        {description}
      </Type.Text>
      <Button label='Dismiss' width='full' type='button' onClick={onPrimaryButtonClick} />
    </Modal>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

export default AlertModal;
